import { PayloadAction } from "@reduxjs/toolkit";

import { initialState } from "@/redux/invoicingAdvance/initialState";
import {
  BankTransactionFilterStateType,
  EWayBillReviewDataType,
  FilterStateType,
  InitialStateInvoicingAdvanceType,
  InvoiceType,
  PaymentStatusFilterKeyType,
  PinCodeDistanceCountDataType,
} from "@/redux/invoicingAdvance/invoicingAdvance-types";

export const invoicingAdvanceReducers = {
  setClientCodeInInvoicingAdvance: (
    state: InitialStateInvoicingAdvanceType,
    action: PayloadAction<number>
  ) => {
    state.clientCode = action.payload;
  },
  setCompanyNameInInvoicingAdvance: (
    state: InitialStateInvoicingAdvanceType,
    action: PayloadAction<string>
  ) => {
    state.companyName = action.payload;
  },
  resetInvoicingAdvanceFetching: (state: InitialStateInvoicingAdvanceType) => {
    state.fetching = false;
  },
  resetInvoicingAdvanceSuccess: (state: InitialStateInvoicingAdvanceType) => {
    state.success = null;
  },
  // Filter reducers

  resetFilterInvoicingAdvance: (state: InitialStateInvoicingAdvanceType) => {
    state.filters = initialState.filters;
  },

  resetSearchStringInInvoicingAdvance: (
    state: InitialStateInvoicingAdvanceType
  ) => {
    state.filters.searchString = "";
  },
  setSearchStringInInvoicingAdvance: (
    state: InitialStateInvoicingAdvanceType,
    action: PayloadAction<string>
  ) => {
    state.filters.searchString = action.payload;
  },

  // single payment status
  togglePaymentStatusFilterInVoicingAdvance: (
    state: InitialStateInvoicingAdvanceType,
    action: PayloadAction<PaymentStatusFilterKeyType>
  ) => {
    const key = action.payload;
    state.filters.paymentStatus[key] = !state.filters.paymentStatus[key];
  },
  // for all status
  setAllPaymentStatusInInvoicingAdvance: (
    state: InitialStateInvoicingAdvanceType,
    action: PayloadAction<boolean>
  ) => {
    const value = action.payload;

    state.filters.paymentStatus = {
      all: value,
      partiallyPaid: value,
      pending: value,
      paid: value,
      purchaseOrder: value,
      estimation: value,
    };
  },
  setAllDrawerFilters: (
    state: InitialStateInvoicingAdvanceType,
    action: PayloadAction<FilterStateType>
  ) => {
    state.filters.drawerFilters = action.payload;
  },

  resetAllDrawerFilters: (state: InitialStateInvoicingAdvanceType) => {
    state.filters.drawerFilters = initialState.filters.drawerFilters;
  },
  setSortingValue: (
    state: InitialStateInvoicingAdvanceType,
    action: PayloadAction<string>
  ) => {
    state.filters.sorting = action.payload;
  },
  setOverdueReminderToggleValue: (
    state: InitialStateInvoicingAdvanceType,
    action: PayloadAction<boolean>
  ) => {
    state.filters.isOverdueReminderEnabled = action.payload;
  },
  setActiveAddInvoiceType: (
    state: InitialStateInvoicingAdvanceType,
    action: PayloadAction<InvoiceType | null>
  ) => {
    state.activeAddInvoiceType = action.payload;
  },
  resetSingleInvoiceDetail: (state: InitialStateInvoicingAdvanceType) => {
    state.singleInvoiceDetails = initialState.singleInvoiceDetails;
  },
  resetInvoiceDownloadDetails: (state: InitialStateInvoicingAdvanceType) => {
    state.invoiceDownloadDetails = initialState.invoiceDownloadDetails;
  },
  resetStatusInfo: (state: InitialStateInvoicingAdvanceType) => {
    state.success = initialState.success;
    state.message = initialState.message;
    state.error = initialState.error;
    state.statusCode = initialState.statusCode;
  },
  resetEWayBillError: (state: InitialStateInvoicingAdvanceType) => {
    state.eWayBillError = "";
  },
  resetPinCodeDistanceCountData: (state: InitialStateInvoicingAdvanceType) => {
    state.pinCodeDistanceCountData = {} as PinCodeDistanceCountDataType;
  },
  resetPinCodeError: (state: InitialStateInvoicingAdvanceType) => {
    state.pinCodeError = "";
  },
  resetEWayBillReviewData: (state: InitialStateInvoicingAdvanceType) => {
    state.eWayBillReviewData = {} as EWayBillReviewDataType;
  },
  resetEWayBillUpdateError: (state: InitialStateInvoicingAdvanceType) => {
    state.eWayBillUpdateError = "";
  },
  toggleRefetchCustomerSupplierDetails: (
    state: InitialStateInvoicingAdvanceType
  ) => {
    state.refetchCustomerSupplierDetails =
      !state.refetchCustomerSupplierDetails;
  },
  triggerRefetchInvoiceList: (state: InitialStateInvoicingAdvanceType) => {
    state.refetchInvoicesList += 1;
  },
  triggerRefetchOtherInvoiceList: (state: InitialStateInvoicingAdvanceType) => {
    state.refetchOtherInvoicesList += 1;
  },
  resetRefetchInvoiceList: (state: InitialStateInvoicingAdvanceType) => {
    state.refetchInvoicesList = 0;
  },
  resetRefetchOtherInvoiceList: (state: InitialStateInvoicingAdvanceType) => {
    state.refetchOtherInvoicesList = 0;
  },
  resetBulkUploadData: (state: InitialStateInvoicingAdvanceType) => {
    state.bulkUploadData = null;
  },
  resetSingleOtherInvoiceDetail: (state: InitialStateInvoicingAdvanceType) => {
    state.singleOtherInvoiceDetails = null;
  },
  resetUploadBankStatementMessage: (
    state: InitialStateInvoicingAdvanceType
  ) => {
    state.uploadBankStatementMessage = null;
    state.success = 0;
  },
  resetUploadedBankStatementTransactionList: (
    state: InitialStateInvoicingAdvanceType
  ) => {
    state.uploadedBankStatementTransactionList = [];
    state.uploadedBankStatementTransactionCount = 0;
    state.uploadedBankStatementSummary = {};
  },
  resetTransactionCommentSuccess: (state: InitialStateInvoicingAdvanceType) => {
    state.transactionCommentSuccess = null;
    state.postTransactionCommentSuccess = null;
  },
  resetTransactionCommentList: (state: InitialStateInvoicingAdvanceType) => {
    state.bankStatementTransactionCommentList = [];
  },
  resetBankStatementFileUploadFetching: (
    state: InitialStateInvoicingAdvanceType
  ) => {
    state.fileUploadFetching = false;
  },
  resetBankStatementUploadFetching: (
    state: InitialStateInvoicingAdvanceType
  ) => {
    state.uploadedBankStatementFetching = false;
  },
  resetEmailTimelineFetching: (state: InitialStateInvoicingAdvanceType) => {
    state.emailTimelineFetching = false;
  },
  resetOverdueInvoiceEmailTimelineData: (
    state: InitialStateInvoicingAdvanceType
  ) => {
    state.overdueInvoiceEmailTimelineData = null;
  },
  resetLockUnlockResponseFetching: (
    state: InitialStateInvoicingAdvanceType
  ) => {
    state.lockUnlockResponseFetching = false;
  },
  setBankTransactionFilters: (
    state: InitialStateInvoicingAdvanceType,
    action: PayloadAction<BankTransactionFilterStateType>
  ) => {
    state.bankTransactionFilters = action.payload;
  },
  resetBankTransactionFilters: (state: InitialStateInvoicingAdvanceType) => {
    state.bankTransactionFilters = initialState.bankTransactionFilters;
  },
  resetInvoicingAdvanceSlice: () => initialState,
};
